import React, { useEffect, useMemo } from 'react';
import { getZoomTransform } from '../../../utils/zoomPosition';

const ImagePreviewModal = ({
  imageUrl,
  alt,
  zoomLevel,
  zoomOrigin,
  zoomBounds,
  onClose,
  disableImageReveal = false,
}) => {
  const parsedZoomLevel = Number(zoomLevel);
  const effectiveZoomLevel = Number.isFinite(parsedZoomLevel) ? Math.max(100, parsedZoomLevel) : 100;
  const transform = useMemo(
    () => getZoomTransform(zoomOrigin, effectiveZoomLevel, zoomBounds),
    [zoomOrigin, effectiveZoomLevel, zoomBounds]
  );

  useEffect(() => {
    if (!imageUrl) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose?.();
      }
    };

    const previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [imageUrl, onClose]);

  if (!imageUrl) return null;

  return (
    <div
      className="zi-image-preview-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Expanded generated image"
      onClick={onClose}
    >
      <div className="zi-image-preview-content" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          className="zi-image-preview-close"
          onClick={onClose}
          aria-label="Close image preview"
          title="Close"
        >
          x
        </button>
        <div className="zi-image-preview-viewport">
          <img
            className="zi-image-preview-image"
            src={imageUrl}
            alt={alt || 'Expanded generated image'}
            onContextMenu={
              disableImageReveal
                ? (event) => {
                    event.preventDefault();
                  }
                : undefined
            }
            onDragStart={
              disableImageReveal
                ? (event) => {
                    event.preventDefault();
                  }
                : undefined
            }
            draggable={disableImageReveal ? false : undefined}
            style={{
              width: `${effectiveZoomLevel}%`,
              height: `${effectiveZoomLevel}%`,
              objectFit: 'cover',
              transform,
              userSelect: disableImageReveal ? 'none' : undefined,
              WebkitUserSelect: disableImageReveal ? 'none' : undefined,
              WebkitTouchCallout: disableImageReveal ? 'none' : undefined,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;
